import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Component, Inject, OnInit } from "@angular/core";
import { EnrollSessionService } from "../enrollSession.service";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { RestService } from "../rest.service";
import { IMAGE_URL } from "app/constants";

@Component({
  selector: "app-confirmation-banner-dialog",
  templateUrl: "./confirmation-banner-dialog.component.html",
  styleUrls: ["./confirmation-banner-dialog.component.scss"]
})
export class ConfirmationBannerDialogComponent implements OnInit {
  IMAGE_URL = IMAGE_URL;
  currentWebsite: string;
  destinationWebsite: string;
  message: string;
  
  constructor(
    public dialogRef: MatDialogRef<ConfirmationBannerDialogComponent>,
    public _enrollSession: EnrollSessionService,
    public router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _toastr: ToastrService,
    public _restService: RestService
  ) {
    this.currentWebsite = data.currentWebsite || window.location.hostname;
    this.destinationWebsite = data.destinationWebsite || "puriumenrollment.com";
    this.message = `You are about to leave ${this.currentWebsite} and go to ${this.destinationWebsite}`;
  }

  ngOnInit(): void {
    // Auto-close after 10 seconds if user does not interact
    setTimeout(() => {
      this.onCancel();
    }, 10000);
  }

  // onContinue(): void {
  //   // User clicked Continue, proceed to the external site
  //   const url = this._enrollSession.data.webAlias ? 
  //     "https://puriumenrollment.com/Home?giftcard=" + this._enrollSession.data.webAlias : 
  //     "https://puriumenrollment.com";
  //   window.open(url, "_blank");
  //   this.dialogRef.close("continue");
  // }
  onContinue(): void {
    // User clicked Continue, proceed to the external site
    let url: string;
    
    if (this.destinationWebsite === 'puriumenrollment.com') {
      // For puriumenrollment.com, use the specific URL pattern with giftcard parameter
      url = this._enrollSession.data.webAlias ? 
        "https://puriumenrollment.com/Home?giftcard=" + this._enrollSession.data.webAlias : 
        "https://puriumenrollment.com";

        window.open(url, "_blank");
    } else if (this.destinationWebsite === 'ishoppurium.com') {
      // For phpenrollnew.wsicloud.net, use simple URL without giftcard parameter
      url = "https://ishoppurium.com";
      window.open(url, "_blank");
    } else if (this.destinationWebsite === 'homepage') {
      // For phpenrollnew.wsicloud.net, use simple URL without giftcard parameter
       this.router.navigate(['/']);
    } else if (this.destinationWebsite === 'Ultlifestyle') {
      this.router.navigate(['/Ultlifestyle']);
    } else {
      // Fallback for any other destination website
      this.router.navigateByUrl('/Ultlifestyle');
    }
    
    
    this.dialogRef.close("continue");
  }

  onCancel(): void {
    // User clicked Cancel or timeout, stay on current page
    this.dialogRef.close("cancel");
  }
}
